<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <h3 class="primary--text mb-4">{{ textCompanyLabel }}</h3>
    <v-row>
      <v-col cols="12" md="9" class="pr-md-5">
        <BaseFilter
          v-model="search"
          v-bind="filterProps"
          textPlaceholder="Buscar"
          @search="searchByFilter"
        />
      </v-col>
      <v-col cols="12" md="3" class="mb-xs-5 mb-sm-5">
        <BaseButton
          class="secondary text-uppercase subtitle-2 font-weight-bold"
          style="width: 100%"
          @click="goToNewCompany"
        >
          <v-icon class="pr-4 add-icon">fa-plus</v-icon>
          Adicionar
        </BaseButton>
      </v-col>
      <v-col cols="12">
        <p class="primary--text font-weight-bold mb-0">Filtrar</p>
      </v-col>
      <v-col cols="12" md="3" class="pr-md-5">
        <BaseFormSelect
          ref="tipoSelect"
          id-element="tipo"
          placeholder="Tipo"
          v-model="filter.byKind"
          :items="filterTomadores"
          required
        />
      </v-col>
      <v-col cols="12" md="2">
        <BaseFormSelect
          ref="statusSelect"
          id-element="status"
          placeholder="Status"
          v-model="filter.byStatus"
          :items="['Todos', 'Ativos', 'Inativos']"
          required
        />
      </v-col>
      <v-col cols="12" md="3"></v-col>
      <v-col cols="12" md="2" class="pr-md-5 mt-md-2">
        <BaseButton
          text
          class="secondary text-uppercase subtitle-2 font-weight-bold"
          style="width: 100%"
          @click="searchByFilter"
        >
          Pesquisar
        </BaseButton>
      </v-col>
      <v-col cols="12" md="2" class="mt-md-2">
        <v-btn
          outlined
          color="secondary"
          class="text-uppercase subtitle-2 font-weight-bold"
          style="width: 100%"
          @click="clearFilterOptions"
        >
          Limpar
        </v-btn>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="companies.items"
          :server-items-length="companies.total_count"
          no-data-text="Não há Grupos Econômicos cadastrados."
          loading-text="Carregando groups econômicos..."
          :options.sync="filterOptions"
          :loading="listLoading"
          class="eg-table"
          @click:row="viewCompany"
        >
          <template v-slot:[`item.cnpj`]="{ item }">
            <div :class="borderColor(item.status)">
              {{ formatCNPJ(item.cnpj) }}
            </div>
          </template>
          <template v-slot:[`item.subsidiaria`]="{ item }">
            {{ types[item.subsidiaria] }}
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
  </Main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import {
  CommonPayload as ResourceFilterMixin,
  defaultFilterOptions
} from "@/mixins/PayloadDataTableMixin";
import { maskCNPJ } from "@/utils/masks.js";
import _ from "lodash";
const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};

const filterTomadoresGarantia = ['Todos', 'Tomadores Matriz', 'Tomadores Filiais'];
const filterTomadoresAgro = ['Todos', 'Matrizes', 'Filiais'];

const tableHeaders = [
  { text: "CNPJ", value: "cnpj", sortable: true },
  { text: "Nome", value: "nome_fantasia", sortable: true },
  { text: "Tipo", value: "subsidiaria", sortable: false },
  { text: "Status", value: "status.nome", sortable: false }
];

const colorByStatus = {
  ativo: "blue",
  inativo: "pink"
};
const DEFAULT_STATUS_COLOR = "yellow";

export default {
  name: "CompaniesList",
  mixins: [LoadingRequest, ResourceFilterMixin],
  data: () => ({
    types: { false: "MATRIZ", true: "FILIAL" },
    currentTab: 0,
    search: "",
    listLoading: false,
    tableHeaders,
    filterProps: defaultFilterProps,
    filter: {
      byKind: "Todos",
      byStatus: "Todos"
    },
    filterOptions: {
      ...defaultFilterOptions(),
      byKind: "Todos",
      byStatus: "Todos"
    },
    maskCNPJ,
    filterTomadoresGarantia,
    filterTomadoresAgro
  }),
  computed: {
    ...mapState("economic_group", ["economicGroup", "companies"]),
    ...mapState("me", ["userAreaIsGarantia"]),
    textCompanyLabel() {
      return this.userAreaIsGarantia ? "TOMADORES MATRIZ E FILIAIS" : "EMPRESAS DO GRUPO";
    },
    filterTomadores() {
      return this.userAreaIsGarantia ? this.filterTomadoresGarantia : this.filterTomadoresAgro;
    },
    groupId() {
      return this.$route.params.groupId;
    },
    breadcrumb() {
      const { nome } = this.economicGroup || { nome: "" };
      return [
        {
          text: `Grupo Econômico: ${nome}`,
          to: "economic_group view"
        }
      ];
    }
  },
  methods: {
    ...mapActions("economic_group", ["listCompanies", "selectCompany"]),
    previousPage() {
      this.$router.push({
        name: "economic_group view",
        params: { groupId: this.groupId }
      });
    },
    borderColor(item) {
      const statusColor = colorByStatus[item.id] || DEFAULT_STATUS_COLOR;
      return `eg-table__border eg-table__border-${statusColor}`;
    },
    goToNewCompany() {
      this.$router.push({
        name: "choose economic_group company subsidiary",
        params: { groupId: this.groupId }
      });
    },
    viewCompany(item) {
      this.selectCompany(item);
      this.$router.push({
        name: "economic_group company",
        params: {
          groupId: this.groupId,
          companyId: item.id
        }
      });
    },
    performFilter(groupId, filter) {
      this.withLoading(this.listCompanies({ groupId, filter }));
    },
    searchByFilter() {
      this.filterOptions.byKind = _.cloneDeep(this.filter.byKind);
      this.filterOptions.byStatus = _.cloneDeep(this.filter.byStatus);
      this.performFilter(
        this.groupId,
        this.toLSPCompanyFilter(this.filterOptions, this.search)
      );
    },
    clearFilterOptions() {
      this.filter.byKind = "Todos";
      this.filter.byStatus = "Todos";
      this.filterOptions = {
        ...defaultFilterOptions(),
        byKind: "Todos",
        byStatus: "Todos"
      };
      this.search = "";
      this.searchByFilter();
    },
    fetchData() {
      this.searchByFilter();
    },
    formatCNPJ(value) {
      let i = 0;
      return value
        ? this.maskCNPJ[0].replace(/#/g, () => value[i++] || "")
        : "";
    }
  },
  watch: {
    filterOptions: {
      handler() {
        this.searchByFilter();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style lang="sass">
.eg-table
  .v-data-table__wrapper
    @media (min-width:960px)
      overflow: visible !important
  td
    position: relative

  &__border::before
    overflow: visible !important
    display: block
    position: absolute
    background-color: #CCC
    width: 5px
    border-radius: 2px
    top: 8px
    bottom: 8px
    left: 0px
    margin-left: -3px
    content: " "
  &__border-blue::before
    background-color: var(--v-secondary-base) !important
  &__border-yellow::before
    background-color: var(--v-yellow-base) !important
  &__border-pink::before
    background-color: var(--v-pink-base) !important
</style>
